import { Action } from '@ngrx/store';
import { IAccount } from '../../../../commons';

export enum AccountActionTypes {
  LoadAccountState = '[Account] Load Account State',
  LoadAccountStateSuccess = '[Account] Load Account State Success',
  LoadAccountStateFail = '[Account] Load Account State Fail',
  AccountScreenErrorReset = '[Account] Account Screen Error Reset'

}

export class LoadAccountState implements Action {
  readonly type = AccountActionTypes.LoadAccountState;
}

export class LoadAccountStateSuccess implements Action {
  readonly type = AccountActionTypes.LoadAccountStateSuccess;
  constructor(public payload: IAccount ) {}
}

export class LoadAccountStateFail implements Action {
  readonly type = AccountActionTypes.LoadAccountStateFail;
  constructor(public payload: any) {}
}

export class AccountScreenErrorReset implements Action {
  readonly type = AccountActionTypes.AccountScreenErrorReset;
}

export type AccountActions = 
  LoadAccountState
  | LoadAccountStateSuccess
  | LoadAccountStateFail
  | AccountScreenErrorReset;